import { MRQStatusesOptions } from "../../../lib/systemData"
import { getMRQStatusLabelFromId } from "../../../lib/labels"
import WorkQDeferredCustomSelect from "./WorkQDeferredCustomSelect"
import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { filterActions } from "../../../store/filter"
import { caseQuickUpdate } from "../../../lib/fetchApi"
import { notificationActions } from "../../../store/notifications"

function isEmptyMrqStatus(value) {
    return value == null || value === ""
}

export default function MRQStatusCell({data, item, caseData}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const selectedWorkQueue = useSelector(state => state.workqueue.selectedWorkQueue)
    const workqSlug = selectedWorkQueue?.slug || selectedWorkQueue
    const [localValue, setLocalValue] = useState(data)
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        if (isSaving) return
        if (isEmptyMrqStatus(data) && !isEmptyMrqStatus(localValue)) return
        setLocalValue(data)
    }, [data, isSaving, localValue])

    const fallbackSelectedOption = useCallback((value) => {
        if (isEmptyMrqStatus(value)) return null
        const found = MRQStatusesOptions(true)?.find((item) => item.value == value)
        if (found) {
            return { ...found, isDisabled: true }
        }
        const label = getMRQStatusLabelFromId(value)
        if (!label) return null
        return { label, value, isDisabled: true }
    }, [])

    async function updateHandler(payload, previousValue, nextValue) {
        setIsSaving(true);

        let reqBody = {
            type: payload.identifier.type,
            type_id: payload.identifier.type_id,
            workq: workqSlug,
            fields: {
                [payload.identifier.field] : nextValue,
            }
        }     

        let dispatchBody = {
            case_id: payload.identifier.case_id,
            folder: payload.identifier.folder,
            item: {
                itemId: payload.identifier.type_id,
                fields: [
                    {
                        field: payload.identifier.field,
                        value: nextValue
                    }
                ]              
            },
        }

        let update = await caseQuickUpdate(userToken, payload.identifier.case_id, reqBody, null, true)

        if (update && update.errorMessage) {
            setLocalValue(previousValue);
            dispatch(
                filterActions.updateItemInWorkQRow({
                    case_id: payload.identifier.case_id,
                    folder: payload.identifier.folder,
                    item: {
                        itemId: payload.identifier.type_id,
                        fields: [{ field: payload.identifier.field, value: previousValue }],
                    },
                }),
            );
            dispatch(notificationActions.setError(update))
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Your changes have been successfully saved to the case.`, type: 'success'}))
            
            dispatch(filterActions.updateItemInWorkQRow(dispatchBody))
        }    
        setIsSaving(false);
                
    }

    function onChange(payload) {
        const previousValue = localValue;
        const nextValue = payload?.data?.value ?? null;
        setLocalValue(nextValue);
        dispatch(
            filterActions.updateItemInWorkQRow({
                case_id: payload.identifier.case_id,
                folder: payload.identifier.folder,
                item: {
                    itemId: payload.identifier.type_id,
                    fields: [{ field: payload.identifier.field, value: nextValue }],
                },
            }),
        );
        updateHandler(payload, previousValue, nextValue);
    }

    return <div style={{position: 'relative'}}>
        
        <WorkQDeferredCustomSelect
            fixedDrawer={true}
            hasRemove={true}
            getOptionsData={MRQStatusesOptions}
            preSelectedValue={localValue}
            fallbackSelectedOption={fallbackSelectedOption}
            action={onChange}
            name={'mrq_status_id'}
            identifier={{type: 'case_practice', field: 'mrq_status_id', type_id: item.id, folder: 'practices', case_id: caseData.case?.id}}
            sameSizeAsContainer={true}
            minWidth={150}
            isLoading={isSaving}
        />
                                        
    </div>
}
